import { Component, FormEvent, useState } from "react";
import { Editor } from "react-draft-wysiwyg";
import { EditorState, convertToRaw } from "draft-js";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import draftToHtml from "draftjs-to-html";
import { useParams } from "react-router-dom";
import { newCommentApi } from "../../services/thread";
import { useAuth } from "../../context/authprovider";
import { toast } from "react-toastify";
import { CSRFToken } from "../../services/auth";

const NewComment = () => {
  const { threadId } = useParams();
  const [content, setContent] = useState<string>("");
  const [editorState, setEditorState] = useState<EditorState>(
    EditorState.createEmpty()
  );
  const { userId } = useAuth();

  const onEditorStateChange = (editorState: any) => {
    const text = editorState.getCurrentContent().getPlainText("");
    const lines = text ? text.split("\n") : 0;

    if (lines.length > 15) {
      console.log("Handle here");
    } else {
      setEditorState(editorState);
      setContent(draftToHtml(convertToRaw(editorState.getCurrentContent())));
    }
  };

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("commentContent", content);
    formData.append("threadId", threadId!);
    formData.append("userId", userId!);

    try {
      const response = await newCommentApi(formData);
      if (response === "Success") {
        window.location.reload();
      }
    } catch (e) {}
  };

  return (
    <>
      <form
        className="w-1/2 flex flex-col justify-center max-h-screen"
        onSubmit={handleSubmit}
      >
        <CSRFToken />
        <Editor
          toolbar={{
            options: [
              "inline",
              "blockType",
              "fontSize",
              "fontFamily",
              "list",
              "textAlign",
              "colorPicker",
              "link",
              "emoji",
              "history",
            ],
            inline: { inDropdown: true },
            // list: { inDropdown: true },
            // textAlign: { inDropdown: true },
            link: { inDropdown: true },
            fontFamily: {
              options: [
                "Arial",
                "Georgia",
                "Impact",
                "Tahoma",
                "Roboto",
                "Times New Roman",
                "Verdana",
              ],
            },
          }}
          editorState={editorState}
          placeholder="Type here"
          wrapperClassName="w-full block leading-normal"
          toolbarClassName="p-0 border-0 bg-white"
          editorClassName="h-auto min-h-full"
          onEditorStateChange={onEditorStateChange}
        />
        <button
          type="submit"
          className="w-fit h-min text-white bg-blue-700 hover:bg-blue-800 focus:outline-none focus:ring-4 focus:ring-blue-300 font-medium rounded-full text-sm px-5 py-2.5 text-center mr-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
        >
          Post New Comment
        </button>
      </form>
    </>
  );
};

export default NewComment;
